import React, { Fragment } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import SecBanner from '../../component/Page/SecBanner'

const About = () => {
    return (
        <Fragment>
            <div className="overflow-hidden font-poppins">

                <div className="bg__blue-2">
                    <Navbar />
                    <Head title="Nuestra Historia - ListoPago" />
                </div>
                <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />


                <section>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 mb-4 my-md-auto">
                                <img src="./../images/Collaboration-cuate.png" alt="" style={{ width: '100%' }} />
                            </div>
                            <div className="col-md-6 my-auto">
                                <h2 className="semi-bold font__size--72 text__70-1024 text__70-md text__70-sm mb-4">Así nació ListoPago</h2>
                                <p className="medium font__size--16 text__16-1024 color__gray-1 lh-2 mb-3">
                                    Todo empezó en una tarde cualquiera, en una esquina de mi ciudad.
                                </p>
                                <p className="medium font__size--16 text__16-1024 color__gray-1 lh-2 mb-3">
                                    Fui a comprar unas salchipapas — como miles de colombianos lo hacen cada día — y mientras esperaba, vi algo que me impactó:
                                </p>
                                <p className="medium font__size--16 text__16-1024 color__gray-1 lh-2 mb-3">
                                    El dueño del puesto recibió una transferencia por Nequi. Sacó su celular, tomó una foto al comprobante… y luego otra… y otra más.
                                </p>
                                <p className="medium font__size--16 text__16-1024 color__gray-1 lh-2 mb-4">
                                    Al final del turno, se sentó solo, bajo la luz tenue de un bombillo, y pasó más de dos horas revisando una por una esas fotos.
                                </p>
                                <p className="medium font__size--14 text__14-1024 color__gray-1 lh-2 mb-4" style={{ fontStyle: 'italic', paddingLeft: '20px', borderLeft: '3px solid rgb(17, 112, 223)' }}>
                                    — ¿Ya anoté esta?<br />
                                    — ¿Fue $10.000 o $12.000?<br />
                                    — ¿Era de Nequi o de Bancolombia?
                                </p>
                                <p className="semi-bold font__size--16 text__16-1024 lh-2 mb-0">
                                    En ese momento entendí: no le faltaba tecnología… le faltaba tiempo.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container">
                        <div className="text-center mb-5">
                            <h2 className='semi-bold font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx'>💡 La chispa</h2>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-lg-8 text-center">
                                <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1 mb-3'>
                                    ¿Y si una app pudiera leer esas fotos automáticamente?
                                </p>
                                <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1 mb-3'>
                                    ¿Y si, en segundos, convirtiera cada comprobante en una transacción organizada?
                                </p>
                                <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1 mb-4'>
                                    ¿Y si el cierre de caja no tomara horas, sino minutos?
                                </p>
                                <p className='semi-bold font__size--20 text__20-1024 lh-2 mb-2' style={{ color: 'rgb(17, 112, 223)' }}>
                                    Así nació ListoPago:
                                </p>
                                <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1'>
                                    Una app hecha por un emprendedor, para emprendedores, que entiende que tu tiempo vale más que cualquier cosa.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container">
                        <div className="text-center mb-5">
                            <h2 className='semi-bold font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx'>🚀 Hoy, ListoPago va más allá</h2>
                            <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1 mt-3'>
                                No solo conciliamos ingresos:
                            </p>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-md-6 col-lg-5 mb-4">
                                <div className="card border-0 rounded__12 p-4 h-100 text-center shadow-sm" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                                    <div className="icon mb-4 d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
                                        <span style={{ fontSize: '40px', textAlign: 'center', display: 'block' }}>✅</span>
                                    </div>
                                    <h4 className='semi-bold font__size--18 text__18-1024 mb-3'>Lectura automática</h4>
                                    <p className='medium font__size--14 text__14-1024 lh-2 color__gray-1 mb-0'>Leemos transferencias de Bancolombia, Nequi, Daviplata y más.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-5 mb-4">
                                <div className="card border-0 rounded__12 p-4 h-100 text-center shadow-sm" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                                    <div className="icon mb-4 d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
                                        <span style={{ fontSize: '40px', textAlign: 'center', display: 'block' }}>✅</span>
                                    </div>
                                    <h4 className='semi-bold font__size--18 text__18-1024 mb-3'>Registro de egresos</h4>
                                    <p className='medium font__size--14 text__14-1024 lh-2 color__gray-1 mb-0'>Registramos egresos (compras, pagos a proveedores, gastos del día).</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-5 mb-4 mb-md-0">
                                <div className="card border-0 rounded__12 p-4 h-100 text-center shadow-sm" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                                    <div className="icon mb-4 d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
                                        <span style={{ fontSize: '40px', textAlign: 'center', display: 'block' }}>✅</span>
                                    </div>
                                    <h4 className='semi-bold font__size--18 text__18-1024 mb-3'>Organización por turnos</h4>
                                    <p className='medium font__size--14 text__14-1024 lh-2 color__gray-1 mb-0'>Organizamos todo por turnos: mañana, tarde, noche y madrugada.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-5 mb-4 mb-md-0">
                                <div className="card border-0 rounded__12 p-4 h-100 text-center shadow-sm" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                                    <div className="icon mb-4 d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
                                        <span style={{ fontSize: '40px', textAlign: 'center', display: 'block' }}>✅</span>
                                    </div>
                                    <h4 className='semi-bold font__size--18 text__18-1024 mb-3'>Reportes al instante</h4>
                                    <p className='medium font__size--14 text__14-1024 lh-2 color__gray-1 mb-0'>Generamos reportes para que sepas, al instante, cómo va tu negocio.</p>
                                </div>
                            </div>
                        </div>

                        <div className="text-center mt-5">
                            <p className='semi-bold font__size--20 text__20-1024 lh-2 mb-3'>Y lo mejor:</p>
                            <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1'>
                                ✨ 15 días gratis de prueba. Sin suscripción.
                            </p>
                            <p className='medium font__size--16 text__16-1024 lh-2 color__gray-1'>
                                Porque creemos que la tecnología debe servirte a ti — no al revés.
                            </p>
                        </div>
                    </div>
                </section>

                <section style={{ backgroundColor: 'rgba(17, 112, 223, 0.05)', padding: '80px 0' }}>
                    <div className="container">
                        <div className="text-center mb-4">
                            <h2 className='semi-bold font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx'>❤️ Para quienes construyen Colombia</h2>
                        </div>
                        
                        <div className="row justify-content-center">
                            <div className="col-lg-9">
                                <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1 mb-4 text-center'>
                                    ListoPago no es solo una app.
                                </p>
                                <p className='medium font__size--18 text__18-1024 lh-2 color__gray-1 mb-5 text-center'>
                                    Es un homenaje a esos miles de dueños de tiendas, cafeterías, salchipaperías y puestos de mercado que trabajan desde el amanecer hasta la madrugada… y merecen cerrar su caja con tranquilidad, no con estrés.
                                </p>
                                
                                <div className="text-center">
                                    <p className='semi-bold font__size--18 text__18-1024 lh-2 mb-2'>
                                        Gracias por confiar en nosotros.
                                    </p>
                                    <p className='semi-bold font__size--18 text__18-1024 lh-2 mb-5'>
                                        Vamos a seguir construyendo juntos.
                                    </p>
                                    
                                    <p className='medium font__size--16 text__16-1024 lh-2 color__gray-1' style={{ fontStyle: 'italic' }}>
                                        — Brandon Stiven, fundador de ListoPago<br />
                                        Medellín, Colombia
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <SecBanner />

                <Footer />
            </div >
        </Fragment >
    )
}

export default About
